import { TauriUpdaterPrompt } from '@/components/modal/tauri-updater-prompt';
import { Button } from '@heidi/design-system/button';
import { TypographyCaption, TypographyP2SemiBold } from '@heidi/design-system/typography';
import { isTauri } from '@heidi/runtime/platform';
import { atom, useAtom, useSetAtom } from 'jotai';
import { FormattedMessage } from 'react-intl';

const previewOpenAtom = atom(false);

const canPreview = () =>
  process.env.NEXT_PUBLIC_ENVIRONMENT !== 'production' && !isTauri();

export function DesktopUpdaterDevSection({
  onRequestClose,
}: Readonly<{ onRequestClose?: () => void }>) {
  const setOpen = useSetAtom(previewOpenAtom);
  if (!canPreview()) return null;

  return (
    <section aria-labelledby="dev-tools-desktop-updater-heading" className="mb-6">
      <TypographyP2SemiBold id="dev-tools-desktop-updater-heading" className="mb-2">
        <FormattedMessage defaultMessage="Desktop update prompt" id="drYx+kk6pe" />
      </TypographyP2SemiBold>
      <TypographyCaption className="mb-3 text-text-tertiary">
        <FormattedMessage
          defaultMessage="Preview the desktop update prompt in this web build. This does not check for or install an update."
          id="XLBUC3vxW1"
        />
      </TypographyCaption>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="w-full"
        onClick={() => {
          setOpen(true);
          onRequestClose?.();
        }}
        data-testid="dev-tools-desktop-updater-show"
      >
        <FormattedMessage defaultMessage="Show update prompt" id="a6WGHnsYdy" />
      </Button>
    </section>
  );
}

export function DesktopUpdaterDevHost() {
  const [open, setOpen] = useAtom(previewOpenAtom);
  if (!canPreview() || !open) return null;

  return (
    <TauriUpdaterPrompt
      open
      isInstalling={false}
      onClose={() => setOpen(false)}
      onInstall={() => setOpen(false)}
    />
  );
}
